module.exports = __webpack_public_path__ + "img/tarjeta debito verde.037317d0.svg";